export const inboundConstants = {
    RESET: 'RESET',
    INBOUND_FETCHING: 'INBOUND_FETCHING',
    INBOUND_FETCHED: 'INBOUND_FETCHED',
    INBOUND_SUBMITTING: 'INBOUND_SUBMITTING',
    INBOUND_SUBMITTED: 'INBOUND_SUBMITTED',
    //unloadlist
    INBOUND__GROUP_UNLOADLIST_BY_RELEASE: 'INBOUND__GROUP_UNLOADLIST_BY_RELEASE',
    INBOUND_UNLOADLIST_BY_RELEASE_ID: 'INBOUND_UNLOADLIST_BY_RELEASE_ID',
    INBOUND_UNLOADLIST_DATA: 'INBOUND_UNLOADLIST_DATA',
    INBOUND_DESTINATIONS: 'INBOUND_DESTINATIONS',
    INBOUND_UNLOADLIST_DATA_FOR_CREATE: 'INBOUND_UNLOADLIST_DATA_FOR_CREATE',
    //tallysheet
    INBOUND_UNLOADLIST_FOR_TALLYSHEET_CREATION: 'INBOUND_UNLOADLIST_FOR_TALLYSHEET_CREATION',
    //cargo arrival notice
    INBOUND_CAN_DESTINATIONS: 'INBOUND_CAN_DESTINATIONS',
    INBOUND_CARGO_ARRIVAL_NOTICE: 'INBOUND_CARGO_ARRIVAL_NOTICE',
    INBOUND_CARGO_ARRIVAL_NOTICE_PERBOOKING: 'INBOUND_CARGO_ARRIVAL_NOTICE_PERBOOKING',
    INBOUND_CARGO_ARRIVAL_NOTICE_PERBOOKING_RESET: 'INBOUND_CARGO_ARRIVAL_NOTICE_PERBOOKING_RESET',
    //tallysheet
    INBOUND_TALLYSHEET_LIST: 'INBOUND_TALLYSHEET_LIST',
    INBOUND_TALLYSHEET_BY_CODE: 'INBOUND_TALLYSHEET_BY_CODE',
    //cargo release order
    INBOUND_CRO: 'INBOUND_CRO',
    INBOUND_CRO_BY_BOOKING: 'INBOUND_CRO_BY_BOOKING',
    INBOUND_CRO_BY_RELEASE_ORDER_ID: 'INBOUND_CRO_BY_RELEASE_ORDER_ID',
    //cargo delivery receipt
    INBOUND_CDR: 'INBOUND_CDR',
    INBOUND_CDR_BY_BOOKING: 'INBOUND_CDR_BY_BOOKING',
    INBOUND_CDR_BY_ID: 'INBOUND_CDR_BY_ID',
    //cts
    INBOUND_CTS: 'INBOUND_CTS',
    INBOUND_CTS_BY_ID: 'INBOUND_CTS_BY_ID',
    INBOUND_CTS_BY_BOOKING: 'INBOUND_CTS_BY_BOOKING',
    INBOUND_CTS_BY_BOOKING_TANDEM: 'INBOUND_CTS_BY_BOOKING_TANDEM',
    // Voyage List
    GET_VOYAGE_ARRIVALNOTICE: 'GET_VOYAGE_ARRIVALNOTICE',
    GET_VOYAGE_UNLOADLIST: 'GET_VOYAGE_UNLOADLIST',
    GET_VOYAGE_UNLOADLIST_TALLYSHEET: 'GET_VOYAGE_UNLOADLIST_TALLYSHEET',
    // Van-In
    GET_CONTAINER_VAN_FOR_VANIN: 'GET_CONTAINER_VAN_FOR_VANIN',
    INBOUND_LOAD_VANIN_EMPTY: 'INBOUND_LOAD_VANIN_EMPTY',
    INBOUND_GET_VANIN_BY_ID: 'INBOUND_GET_VANIN_BY_ID',
    INBOUND_GET_CTS_VAN_DETAILS: 'INBOUND_GET_CTS_VAN_DETAILS',
    INBOUND_GET_CTS_DETAILS: 'INBOUND_GET_CTS_DETAILS',
    INBOUND_DEMMURAGE: 'INBOUND_DEMMURAGE',
    INBOUND_GET_CTS_VAN_TANDEM_DETAILS: 'INBOUND_GET_CTS_VAN_TANDEM_DETAILS',
    INBOUND_TANDEM_DEMMURAGE: 'INBOUND_TANDEM_DEMMURAGE',
    INBOUND_GET_CTS_TANDEM_DETAILS: 'INBOUND_GET_CTS_TANDEM_DETAILS',
    // Vessel Arrival Notice
    GET_VOYAGE_VESSELARRIVALNOTICE: 'GET_VOYAGE_VESSELARRIVALNOTICE',
    INBOUND_VESSEL_ARRIVAL_NOTICE: 'INBOUND_VESSEL_ARRIVAL_NOTICE',
    // CRO Clearance
    GET_VOYAGE_CROCLEARANCE: 'GET_VOYAGE_CROCLEARANCE',
    INBOUND_GET_CROCLEARANCE: 'INBOUND_GET_CROCLEARANCE',
    INBOUND_GET_CROUNPAIDWB: 'INBOUND_GET_CROUNPAIDWB',
    GET_DISPATCH_LIST: 'GET_DISPATCH_LIST',
    GET_ARCHIVE_DISPATCH_LIST: 'GET_ARCHIVE_DISPATCH_LIST',
    // Dwell Time
    INBOUND_DWELL_TIME: 'INBOUND_DWELL_TIME',
    CONSIGNEE_EMAIL: 'CONSIGNEE_EMAIL',
}